import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpService } from 'app/services/http.service';
import jwt_decode from 'jwt-decode';

import { MessageService } from 'primeng/api';

declare var $: any;

@Component({
  selector: 'app-restablecepassword',
  templateUrl: './restablecepassword.component.html',
  styleUrls: ['./restablecepassword.component.scss']
})
export class RestablecepasswordComponent implements OnInit {

  focus;
  focus1;
  focus2;
  test: number = new Date().getFullYear();
  private toggleButton;
  private sidebarVisible: boolean;
  private nativeElement: Node;
  email: string = '';
  imagenFondo: string;

  newPassword: string = ''
  repeatPassword: string = ''
  tiempoExpirado: boolean = false;

  constructor(private element: ElementRef, private http: HttpService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  checkFullPageBackgroundImage() {
    var $page = $('.full-page');
    var image_src = $page.data('image');

    let fotos = [
      './assets/img/bg/fondoforgot1.jpg',
      './assets/img/bg/fondoforgot2.jpg',
    ]

    let cantidadFotos = fotos.length

    let rdn = Math.floor(Math.random() * cantidadFotos)
    console.log('cantidadFotos', cantidadFotos);
    console.log('rdn', rdn);

    image_src = fotos[rdn]

    if (image_src !== undefined) {
      var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
      $page.append(image_container);
    }
  };

  ngOnInit() {
    console.log('Login ngOnInit');

    this.checkFullPageBackgroundImage();
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      $('.card').removeClass('card-hidden');
    }, 700)

    //Rescata el parámetro que viene desde Órdenes
    this.activatedRoute.params.subscribe(params => {
      let token = params['token'];
      console.log('token', token);

      if (!token) {
        return;
      }

      let datos: any = jwt_decode(token)
      console.log('datos', datos);
      let exp = (datos.exp)
      console.log('exp', new Date(exp));
      console.log('exp', exp);
      console.log('date', new Date());
      console.log('date number', new Date().getTime());
      if (exp < new Date()) {
        this.tiempoExpirado = true;
        return;
      }

      this.email = datos.Email
    })
  }

  cambiaPassword() {

    console.log('cambiaPassword');

    if (this.newPassword != this.repeatPassword) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'La password no coincide.' });
      this.repeatPassword = ''
      return;
    }

    this.http.updatePasswordWithoutOldPasswordService(this.email, this.newPassword).subscribe((data: any) => {
      console.log(data);
      this.messageService.add({ severity: 'success', summary: 'Bien!', detail: 'La password se actualizó correctamente' });

      setTimeout(() => {
        this.router.navigateByUrl('login')
      }, 2000);


    }, (err => {
      console.log('Error:', err);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error });
    }))
  }

  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
  }

  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName('body')[0];
    var sidebar = document.getElementsByClassName('navbar-collapse')[0];
    if (this.sidebarVisible == false) {
      setTimeout(function () {
        toggleButton.classList.add('toggled');
      }, 500);
      body.classList.add('nav-open');
      this.sidebarVisible = true;
    } else {
      this.toggleButton.classList.remove('toggled');
      this.sidebarVisible = false;
      body.classList.remove('nav-open');
    }
  }

}
